import React from 'react';
import cls from './loader.module.scss';
import LoaderEllipse from "../../../assets/loader/LoaderEllipse.svg"
import LoaderLine from "../../../assets/loader/LoaderLine.svg"
import LoaderLogo from "../../../assets/loader/LoaderLogo.svg"

const Loader = () => {

  return (
    <div className={cls.loader_container}>
      <div className={cls.loader_block}>
        <div className={cls.loader_ellipse}>
          <img src={LoaderEllipse} alt='' />
          <img className={cls.loader_line} src={LoaderLine} alt='' />
        </div>
        <img className={cls.loader_logo} src={LoaderLogo} alt='' />
      </div>
    </div>
  );
};

export default Loader;
